import { isDevelopment } from "../config/typedEnv"

type LogLevel = "debug" | "info" | "warn" | "error"

const APP_PREFIX = "[tint-admin]"

const write = (level: LogLevel, scope: string, message: string, ...meta: unknown[]) => {
  if (!isDevelopment) return

  const prefix = `${APP_PREFIX}[${scope}][${level}]`
  const output = [prefix, message, ...meta]

  console.info(...output)
}

export const logger = {
  debug: (scope: string, message: string, ...meta: unknown[]) =>
    write("debug", scope, message, ...meta),
  info: (scope: string, message: string, ...meta: unknown[]) =>
    write("info", scope, message, ...meta),
  warn: (scope: string, message: string, ...meta: unknown[]) =>
    write("warn", scope, message, ...meta),
  error: (scope: string, message: string, ...meta: unknown[]) =>
    write("error", scope, message, ...meta),
}
